import { render } from "./SellerProfileA.vue?vue&type=template&id=0b29af66&scoped=true"
import script from "./SellerProfileA.vue?vue&type=script&lang=js"
export * from "./SellerProfileA.vue?vue&type=script&lang=js"

import "./SellerProfileA.vue?vue&type=style&index=0&id=0b29af66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b29af66"]])

export default __exports__